export default "/images/vendor/flag-icon-css/flags/1x1/ru.svg?c789ea20a0f569d9d6a92d6d34f452a1";